import React, { Fragment, useState } from 'react'
import { Link } from 'react-router-dom'
import './FullscreenHeaderLink.scss'
import { Collapse } from '@material-ui/core'

export default function FullscreenHeaderLink(props) {
  const {
    headerLink,
    items,
    prismicCtx,
    setMenuOpen
  } = props

  const [open, setOpen] = useState(false)



  function handleClick() {
    setOpen(!open)
  }

  let arrowOpen = open ? 'fsHeaderLink__arrow-up' : null
  let dropdown = false
  if (items) {
    if (items.length > 0) {
      dropdown = true
    }
  }
console.log(headerLink)

  return (
    <div style={{ display: 'flex', alignItems: 'center', margin: '10px auto', flexDirection: 'column', padding: 0, marginTop: 10 }}>
      {dropdown && (
        <React.Fragment>
          <div style={{ display: 'flex', alignItems: 'center', padding: 0, margin: 0 }}>
            <div
              className='fsHeaderLink__nav-link fsHeaderLink__nav-link-ltr'
              // to={prismicCtx.linkResolver(headerLink.linkur)}
              style={{ fontSize: 24, margin: 0, padding: 0, cursor: 'pointer' }}
              onClick={handleClick}
            >
              {headerLink.titill[0].text}
            </div>

            <img onClick={handleClick} className={`fsHeaderLink__arrow ${arrowOpen}`} src='/images/arrow.png' alt="Opna" />
          </div>
          <Collapse in={open}>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 20 }}>
              {items.map((item, index) => {

                return (
                  <div key={index} style={{ display: 'flex', margin: '5px 0', padding: 0 }}>
                    {item.linkur.link_type === 'Web'
                      ? (
                        <a
                          style={{ fontSize: 20 }}
                          className='fsHeaderLink__nav-link fsHeaderLink__nav-link-ltr'
                          href={item.linkur.url}
                          onClick={() => setMenuOpen(prev => !prev)}
                        >
                          {item.nafn[0].text}
                        </a>
                      ) : (
                        <Link
                          style={{ fontSize: 20 }}
                          className='fsHeaderLink__nav-link fsHeaderLink__nav-link-ltr'
                          to={prismicCtx.linkResolver(item.linkur)}
                          onClick={() => setMenuOpen(prev => !prev)}
                        >
                          {item.nafn[0].text}
                        </Link>
                      )}
                  </div>
                )
              })}
            </div>
          </Collapse>


        </React.Fragment>
      )}
      {!dropdown && (
        <Fragment>
          {headerLink.linkur.link_type === 'Web' ? (
            <a
              style={{ fontSize: 24 }}
              className='fsHeaderLink__nav-link fsHeaderLink__nav-link-ltr'
              href={headerLink.linkur.url}
              onClick={() => setMenuOpen(prev => !prev)}
            >
              {headerLink.titill[0].text}
            </a>
          ) : (
            <Link
              to={prismicCtx.linkResolver(headerLink.linkur)}
              className='fsHeaderLink__nav-link fsHeaderLink__nav-link-ltr'
              style={{ fontSize: 24 }}
            >
              {headerLink.titill[0].text}
            </Link>
          )}

        </Fragment>

      )}


    </div>

  );
}